import dayjs from "dayjs";
import "dayjs/locale/ko";

dayjs.locale("ko");

// Maintain purely mathematical helper functions for duration
export function addZero(num) {
  return (num < 10 ? "0" : "") + num;
}

export function readableTime(seconds) {
  let hours = Math.floor(seconds / 3600);
  let mins = Math.floor((seconds % 3600) / 60);
  let secs = seconds % 60;

  return [hours ? `${addZero(hours)}시간` : "", mins ? `${addZero(mins)}분` : "", secs ? `${addZero(secs)}초` : ""].filter(Boolean).join(" ");
}

export function secToHHMMDD(seconds) {
  let initHours = Math.floor(seconds / 3600);
  let initMinutes = Math.floor((seconds - initHours * 3600) / 60);
  let initSecs = seconds - initHours * 3600 - initMinutes * 60;

  return { initHours, initMinutes, initSecs };
}

export function readableTimeMinutesSeconds(seconds, type = "mix") {
  // sec
  var hours = Math.floor(seconds / 3600);
  var mins = Math.floor((seconds - hours * 3600) / 60);
  var secs = seconds - hours * 3600 - mins * 60;

  if (type === "seconds") {
    return addZero(secs);
  } else if (type === "minutes") {
    return addZero(mins);
  } else if (type === "hour") {
    return addZero(hours);
  } else if (type === "mix") {
    return `${addZero(mins)}분 ${addZero(secs)}초`;
  }
}

// Date formatters using dayjs

export function dateIncludeTime(source, delimiter = ".") {
  if (!source) return "-";
  return dayjs(source).format(`YYYY${delimiter}MM${delimiter}DD(dd) HH시 mm분`);
}

export function dateIncludeTimeQnA(source, delimiter = ".") {
  // original: YYYY.MM.DD / HH : mm
  return dayjs(source).format(`YYYY.MM.DD / HH : mm`);
}

export function toStringByFormatting(source, delimiter = ".") {
  return dayjs(source).format(`YYYY${delimiter}MM${delimiter}DD (dd)`);
}

export function dashDelimiter(source, delimiter = "-") {
  if (!source) return undefined; // Original behavior returned undefined if source was bad? Optional chaining suggests source could be null.
  // Original: source?.getFullYear() -> undefined if null.
  // BUT: [undefined, undefined, undefined].join('-') -> "--" ?
  // Actually original code:
  // const year = source?.getFullYear(); ...
  // return [year, month, day].join(delimiter);
  // If source is null: year=undefined, month=NaN (leftpad(NaN)), day=NaN.
  // Let's assume input is valid date based on usage, or if undefined return undefined.
  // safe check:
  if (!source) return dayjs(source).isValid() ? dayjs(source).format(`YYYY${delimiter}MM${delimiter}DD`) : undefined;
  
  return dayjs(source).format(`YYYY${delimiter}MM${delimiter}DD`);
}

export const dateFormat = (input) => (input === null ? "-" : toStringByFormatting(new Date(input)));

export const dateFormatTime = (input) => {
  if (input === null) return "-";
  // Original: MM월 DD일 ( HH시 mm분 ) --> Note: space before ( and inside ( )
  // let dateString = month + "월 " + day + "일";
  // let timeString = hours + "시 " + minutes + "분";
  // return dateString + " " + "( " + timeString + " )";
  // "MM월 DD일 ( HH시 mm분 )"
  return dayjs(input).format("MM월 DD일 ( HH시 mm분 )");
};

export const dateFormatTimeAIChart = (input) => {
  if (input === null) return "-";
  // Original: MM월 DD일 HH시 mm분 ss초
  // Note: Original had space after "일 " and space after "분 " but not at end?
  // let dateString = month + "월 " + day + "일 ";
  // let timeString = hours + "시 " + minutes + "분 " + sec + "초";
  // result: MM월 DD일 HH시 mm분 ss초
  return dayjs(input).format("MM월 DD일 HH시 mm분 ss초");
};

export const todayFlag = (input) => dayjs(input).isSame(dayjs(), "day");

export const chatLogTime = (input) => {
  const date = dayjs(input);
  const nowHour = date.hour();
  const nowMt = date.format("mm"); // "05", "30"

  // Preserve specific legacy logic
  if (nowHour <= 12 && nowHour >= 6) {
    return "오전 " + nowHour + ":" + nowMt;
  } else if (nowHour >= 12 && nowHour < 22) {
    return "오후 " + (nowHour - 12) + ":" + nowMt;
  }
  // undefined otherwise
};

export const loginEnableTimeFormat = (input) => {
  const date = dayjs(input);
  
  // Logic from legacy:
  // start = T - 60 mins
  // end = start + 30 mins ( = T - 30 mins )
  
  const start = date.subtract(60, 'minute');
  const end = start.add(30, 'minute');

  const startStr = start.format("HH시 mm분");
  const endStr = end.format("HH시 mm분");

  return `${startStr} ~ ${endStr}`;
};

export const timeFormat = (input) => {
  return dayjs(input).format("YYYY-MM-DD");
};

export const roomTesterListTimeFormat = (input) => {
  if (!input) return "-";
  // Original: YYYY-MM-DD(dd) ( HH시 mm분 )
  return dayjs(input).format("YYYY-MM-DD(dd) ( HH시 mm분 )");
};
